export class Dashboardnotes {
    Notes:string;
    CreatedOn:Date;
    CreatedBy:number; 
    UpdatedOn:Date;
    UpdatedBy:number;
}
